// 注册中心名称
const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
// 产品API
const product = {
  // 查询枚举类
  optionTypes: {
    type: 'get',
    url: `${apiName}/product/base/list/options`
  },
  // 产品查询
  baseList: {
    type: 'post',
    url: `${apiName}/product/base/list`
  },
  // 获取产品供应商下拉选项
  getProductSupplierSelect: {
    type: 'get',
    url: `${apiName}/product/getProductSupplierSelect`
  },

  baseExport: {
    type: 'post',
    url: `${apiName}/product/base/export`
  },

  baseEdit: {
    type: 'post',
    url: `${apiName}/product/base/edit`
  },

  baseDelete: {
    type: 'post',
    url: `${apiName}/product/base/delete`
  },

  // 产品采购列表
  productPurchase: {
    type: 'post',
    url: `${apiName}/product/purchasePrice/list`
  },

  // 分页查询
  listPage: {
    type: 'post',
    url: `${apiName}/product/listpage`
  },
  // 条件查询
  selectforPage: {
    type: 'post',
    url: `${apiName}/product/listpagefor`
  },
  getForCode: {
    type: 'get',
    url: `${apiName}/product/get/`
  },
  put: {
    type: 'post',
    url: `${apiName}/product/put`
  },
  copy: {
    type: 'post',
    url: `${apiName}/product/copy`
  },
  updateForProduct: {
    type: 'post',
    url: `${apiName}/product/update`
  },
  getPoductforEnum: {
    type: 'get',
    url: `${apiName}/product/getProductforEnum`
  },
  getProductForCode: {
    type: 'get',
    url: `${apiName}/product/getProductForCode`
  },
// 清仓信息维护分页查询
  slistPage: {
    type: 'post',
    url: `${apiName}/packClearance/listPage`
  },
  // 根据code查询产品名称
  productName: {
    type: 'get',
    url: `${apiName}/productClearance/getProductName`
  },
  // 根据code查询包件名称
  getPackName: {
    type: 'get',
    url: `${apiName}/packClearance/getPackName`
  },
  // 清仓信息维护新增数据编辑
  saveClearance: {
    type: 'post',
    url: `${apiName}/packClearance/saveClearance`
  },
  // 清仓信息维护根据ID查询表数据
  productById: {
    type: 'get',
    url: `${apiName}/productClearance/productById`
  },
  // 产品基础价格查询分页查询
  produtPriceListPage: {
    type: 'post',
    url: `${apiName}/product/price/listPage`
  },
  // 产品基础价格查询查看调整记录分页查询
  recordListPage: {
    type: 'post',
    url: `${apiName}/product/price/recordListPage`
  },
  addProductRetailPrice: {
    type: 'post',
    url: `${apiName}/product/retailPrice/add`
  },
  waitAddRetailPriceProductList: {
    type: 'post',
    url: `${apiName}/product/retailPrice/waitAddProductList`
  },
  updateProductRetailPrice: {
    type: 'post',
    url: `${apiName}/product/retailPrice/update`
  },
  batchSubmission: {
    type: 'post',
    url: `${apiName}/product/retailPrice/submit`
  },
  batchAudit: {
    type: 'post',
    url: `${apiName}/product/retailPrice/audit`
  },
  removeProductRetailPrice: {
    type: 'post',
    url: `${apiName}/product/retailPrice/remove`
  },
  listRetailPriceAudit: {
    type: 'post',
    url: `${apiName}/product/retailPrice/audit/list`
  },
  listRetailPrice: {
    type: 'post',
    url: `${apiName}/product/retailPrice/list`
  },
  listRetailPriceApprovalComment: {
    type: 'post',
    url: `${apiName}/product/retailPrice/comment/list`
  },
  listMngRetailPrice: {
    type: 'post',
    url: `${apiName}/product/retailPrice/mng/list`
  },
  // 产品上市时间维护分页查询
  marketDateListPage: {
    type: 'post',
    url: `${apiName}/product/marketDate/listPage`
  },
  // 产品上市时间维护保存
  marketDateAddMarketDate: {
    type: 'post',
    url: `${apiName}/product/marketDate/addMarketDate`
  },
  // 产品上市时间维护根据ID查询数据
  getProductMarketById: {
    type: 'get',
    url: `${apiName}/product/marketDate/getProductMarketById`
  },
  // 版块下拉数据
  plateSelect: {
    type: 'post',
    url: `${apiName}/goods/plateSelect`
  },
  // 系列下拉数据
  seriesSelect: {
    type: 'post',
    url: `${apiName}/goods/seriesSelect`
  },
  // 根据产品code模糊查询产品名称
  getLikeProductName: {
    type: 'get',
    url: `${apiName}/productClearance/getLikeProductName`
  },
  // 产品价格系数维护-列表查询
  productPriceCoefficientList: {
    type: 'post',
    url: `${apiName}/ProductPriceCoefficient/list`
  },
  // 产品价格系数维护-新增
  productPriceCoefficientInsertData: {
    type: 'post',
    url: `${apiName}/ProductPriceCoefficient/insertData`
  },
  // 产品价格系数维护-编辑
  productPriceCoefficientUpdateById: {
    type: 'post',
    url: `${apiName}/ProductPriceCoefficient/updateById`
  },
  // 尺寸编辑
  productEdit: {
    type: 'post',
    url: `${apiName}/product/base/productEdit`
  },
  // 基础配置
  // 新增品类
  addCategory: {
    type: 'get',
    url: `${apiName}/product/addCategory`
  },
  // 配置查询
  getCategoryConfig: {
    type: 'post',
    url: `${apiName}/product/getCategoryConfig`
  },
  // 品类和维度 查询
  getCategoryTag: {
    type: 'get',
    url: `${apiName}/product/getCategoryTag`
  },
  // 描述新增、一个或则多个
  addConfigDescribe: {
    type: 'post',
    url: `${apiName}/product/addConfigDescribe`
  },
  // 描述删除、一个或则多个
  delConfigDescribe: {
    type: 'post',
    url: `${apiName}/product/delConfigDescribe`
  },
  // 店铺下拉列表数据
  storeSelect: {
    type: 'get',
    url: `${apiName}/product/storeSelect`
  },
  // 所属类型列表数据
  getType: {
    type: 'get',
    url: `${apiName}/product/getType`
  },
  // 零售价系数调整历史查询列表
  historyListPage: {
    type: 'post',
    url: `/ec-pc-api/ProductPriceCoefficient/historyListPage`
  },
  // 产品查询-图片下载左侧列表
  pictureList: {
    type: 'post',
    url: `/ec-pc-api/product/picture/list`
  },
  // 产品查询-图片下载左侧列表
  pictureSearch: {
    type: 'post',
    url: `/ec-pc-api/product/picture/search`
  },
  // 产品查询-图片下载
  pictureDownload: {
    type: 'post',
    url: `/ec-pc-api/product/picture/download`
  },
  // 包件下架信息维护-新增下架包件
  withdrawAdd: {
    type: 'post',
    url: `/ec-pc-api/pack/withdraw/add`
  },
  // 包件下架信息维护-删除下架包件
  withdrawDel: {
    type: 'get',
    url: `/ec-pc-api/pack/withdraw/del`
  },
  // 上市时间-同步
  listingTimeSync: {
    type: 'post',
    url: `/ec-pc-api/product/listingTime/sync`
  },
  // 上市时间-清空
  listingTimeCleanUp: {
    type: 'post',
    url: `/ec-pc-api/product/listingTime/cleanUp`
  },
  // 重点品型号配置-新增
  categoryBigModelConfigSave: {
    type: 'post',
    url: `/ec-pc-api/product/categoryBigModelConfig/save`
  },
  // 重点品型号配置-编辑
  categoryBigModelConfigUpdate: {
    type: 'post',
    url: `/ec-pc-api/product/categoryBigModelConfig/update`
  },
  // 重点品型号配置-编辑
  categoryBigModelConfigDel: {
    type: 'get',
    url: `/ec-pc-api/product/categoryBigModelConfig/del`
  },
  // 完整价-编辑
  wholePriceUpdate: {
    type: 'post',
    url: `/ec-pc-api/product/wholePrice/update`
  },
  // 文件上传--分页查询
  fileTaskListPage: {
    type: 'post',
    url: `/ec-pc-api/fileTask/listPage`
  },
  //产品检测报告- 文件操作记录--分页查询
  fileOptLogListPage: {
    type: 'post',
    url: `/ec-pc-api/fileTask/fileOptLogListPage`
  },
  // 产品检测报告-删除
  fileTaskDelete: {
    type: 'get',
    url: `/ec-pc-api/fileTask/delete`
  },
  // 产品检测报告-编辑
  fileTaskEdit: {
    type: 'post',
    url: `/ec-pc-api/fileTask/updateFile`
  },
  // 产品销售属性查询
  queryProductAttrInfos: {
    type: 'post',
    url: `/ec-pc-api/product/base/queryProductAttrInfos`
  },
  // 根据产品编码查询调整记录
  adjustLog: {
    type: 'post',
    url: `/ec-pc-api/product/retailPrice/adjustLog`
  },
  // 产品基础属性调整记录
  productBaseAttrAdjustLog: {
    type: 'post',
    url: `/ec-pc-api/product/productPineOrUpDateAdjustLog`
  },
  jdWoodProductList: {
    type: 'post',
    url: `/ec-pc-api/product/jdWoodProductList`
  },
};


export default product;




